import React, { useEffect, useState } from "react";
import {
  Button,
  ButtonToolbar,
  Loader,
  Container,
  Modal,
  Table,
  Footer,
  Pagination,
} from "rsuite";
import "./Customers.css";
import { useTranslation } from "react-i18next";
import CustomHeaderCell from "../../components/Elements/CustomHeaderCell";
import CustomCell from "../../components/Elements/CustomCell";
import { ToastContainer } from "react-toastify";

const ViewExistingCustomers = ({
  existingData,
  openModal,
  setOpenModal,
  ...props
}: {
  existingData?: any;
  openModal: boolean;
  setOpenModal: Function;
}) => {
  const { t } = useTranslation();
  const { Cell, Column } = Table;
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<any[]>([]);

  const [loader, setLoader] = useState(false);

  useEffect(() => {
    if (existingData) {
      setData((prevData) => [...prevData, ...existingData]);
    }
  }, [existingData]);

  return (
    <div className="modal-container">
      {loader && (
        <Loader
          style={{ zIndex: 9999 }}
          size="lg"
          content={t("LOADING")}
          center
          backdrop={true}
        />
      )}
      <Modal
        open={openModal}
        backdrop={false}
        onClose={(e: any) => {
          setOpenModal("");
        }}
        size="lg"
      >
        <Modal.Header>
          <h4 className="text-center">
            {t("VIEW")} {t("EXISTING")} {t("CUSTOMERS")}
          </h4>
        </Modal.Header>
        <Modal.Body>
          <div className="customers view-customers">
            <Container className="container">
              <div
                className={
                  data.length > 0 ? "usr-tbl-border" : "no-record-table"
                }
              >
                <Table
                  height={400}
                  fillHeight={true}
                  data={data}
                  loading={loading}
                  bordered={true}
                  cellBordered
                  hover={true}
                >
                  <Column width={130}>
                    <CustomHeaderCell>{t("MOBILE")}</CustomHeaderCell>
                    <CustomCell dataKey="mobile" />
                  </Column>

                  <Column width={180}>
                    <CustomHeaderCell>
                      {t("FIRST")} {t("NAME")}
                    </CustomHeaderCell>
                    <CustomCell dataKey="fname" />
                  </Column>

                  <Column width={180}>
                    <CustomHeaderCell>
                      {t("LAST")} {t("NAME")}
                    </CustomHeaderCell>
                    <CustomCell dataKey="lname" />
                  </Column>
                  <Column width={100}>
                    <CustomHeaderCell>{t("GENDER")}</CustomHeaderCell>
                    <CustomCell dataKey="gender" />
                  </Column>
                  <Column flexGrow={1}>
                    <CustomHeaderCell>
                      {t("HOUSE_NO")}/{t("ADDRESS")}
                    </CustomHeaderCell>
                    <CustomCell dataKey="house_number" />
                  </Column>
                </Table>
              </div>
              <Footer className="footer">
                <Pagination
                  ellipsis
                  boundaryLinks
                  maxButtons={5}
                  size="xs"
                  layout={["total"]}
                  total={data.length}
                  limit={data.length}
                />
              </Footer>
              <ToastContainer />
              <ButtonToolbar className="btn-center">
                <Button
                  onClick={(e: any) => setOpenModal("")}
                  color="red"
                  appearance="primary"
                >
                  {t("CLOSE")}
                </Button>
              </ButtonToolbar>
            </Container>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default ViewExistingCustomers;
